module.exports = __webpack_public_path__ + "static/media/dropdownGreen.dfd4c5bc.svg";